import React from 'react';
import SubPageTemplate from './SubPageTemplate';

const TermsOfService: React.FC = () => {
  return (
    <SubPageTemplate title="Terms of Service">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-6">
              By accessing and using Book My Shoot's photography services, you accept and agree to be bound 
              by the terms and provision of this agreement. If you do not agree to abide by the above, 
              please do not use this service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
            <p className="text-gray-700 mb-4">
              Book My Shoot provides professional photography services including but not limited to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-6">
              <li>Wedding photography</li>
              <li>Portrait sessions</li>
              <li>Corporate events</li>
              <li>Family photography</li>
              <li>Engagement sessions</li>
              <li>Other special events</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Booking and Payment Terms</h2>
            
            <h3 className="text-xl font-medium text-gray-900 mb-3">3.1 Booking Process</h3>
            <p className="text-gray-700 mb-4">
              All bookings must be made through our official channels. A booking is only confirmed 
              upon receipt of a signed contract and required deposit.
            </p>

            <h3 className="text-xl font-medium text-gray-900 mb-3">3.2 Payment Terms</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-6">
              <li>A non-refundable deposit is required to secure your booking</li>
              <li>Final payment is due before or on the day of the event</li>
              <li>Late payments may incur additional charges</li>
              <li>All prices are in AED unless otherwise specified</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Cancellation and Refund Policy</h2>
            
            <h3 className="text-xl font-medium text-gray-900 mb-3">4.1 Client Cancellation</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Cancellation 30+ days before event: Deposit forfeited</li>
              <li>Cancellation 15-29 days before event: 50% of total fee forfeited</li>
              <li>Cancellation less than 15 days before event: 100% of total fee forfeited</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">4.2 Photographer Cancellation</h3>
            <p className="text-gray-700 mb-6">
              In the unlikely event that we must cancel your booking, we will provide a full refund 
              and assist in finding a replacement photographer if possible.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Intellectual Property Rights</h2>
            
            <h3 className="text-xl font-medium text-gray-900 mb-3">5.1 Copyright</h3>
            <p className="text-gray-700 mb-4">
              All photographs taken by Book My Shoot remain the intellectual property of the photographer 
              until full payment is received and copyright is transferred to the client.
            </p>

            <h3 className="text-xl font-medium text-gray-900 mb-3">5.2 Usage Rights</h3>
            <ul className="list-disc pl-6 text-gray-700 mb-6">
              <li>Clients receive personal usage rights for their photographs</li>
              <li>Commercial usage requires additional licensing agreement</li>
              <li>Photographer retains the right to use images for portfolio and marketing purposes</li>
              <li>Client may not edit or alter photographs without permission</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Client Responsibilities</h2>
            <ul className="list-disc pl-6 text-gray-700 mb-6">
              <li>Provide accurate event details and requirements</li>
              <li>Ensure all necessary permissions are obtained for photography locations</li>
              <li>Inform photographer of any special requirements or restrictions</li>
              <li>Provide timely feedback during the editing process</li>
              <li>Respect the photographer's working conditions and equipment</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Photographer Responsibilities</h2>
            <ul className="list-disc pl-6 text-gray-700 mb-6">
              <li>Arrive on time and prepared for the scheduled session</li>
              <li>Provide professional photography services as agreed</li>
              <li>Deliver edited photographs within the agreed timeframe</li>
              <li>Maintain professional conduct throughout the event</li>
              <li>Respect client privacy and confidentiality</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 mb-6">
              Book My Shoot's liability is limited to the total amount paid for the photography services. 
              We are not liable for any indirect, incidental, or consequential damages. In case of 
              equipment failure or circumstances beyond our control, we will make every effort to provide 
              alternative solutions.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Force Majeure</h2>
            <p className="text-gray-700 mb-6">
              Neither party shall be liable for any failure or delay in performance due to circumstances 
              beyond their reasonable control, including but not limited to acts of God, natural disasters, 
              war, terrorism, or government actions.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Privacy and Data Protection</h2>
            <p className="text-gray-700 mb-6">
              We are committed to protecting your privacy and personal data. Our collection, use, and 
              protection of your information is governed by our Privacy Policy, which forms part of 
              these terms.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Dispute Resolution</h2>
            <p className="text-gray-700 mb-6">
              Any disputes arising from these terms or our services will be resolved through good faith 
              negotiation. If resolution cannot be reached, disputes will be subject to the jurisdiction 
              of the courts of the United Arab Emirates.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Modifications to Terms</h2>
            <p className="text-gray-700 mb-6">
              We reserve the right to modify these terms at any time. Changes will be posted on our 
              website and will become effective immediately. Continued use of our services after 
              changes constitutes acceptance of the new terms.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Governing Law</h2>
            <p className="text-gray-700 mb-6">
              These terms are governed by the laws of the United Arab Emirates. Any legal proceedings 
              will be conducted in the courts of the UAE.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">14. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              For questions about these Terms of Service, please contact us:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700 mb-2"><strong>Email:</strong> legal@bookmyshot.com</p>
              <p className="text-gray-700 mb-2"><strong>Phone:</strong> +971 50 123 4567</p>
              <p className="text-gray-700"><strong>Address:</strong> Dubai, UAE</p>
            </div>
    </SubPageTemplate>
  );
};

export default TermsOfService;
